export default __webpack_public_path__ + "static/tablet_sek2_KV07-0161412e2ffa40ab91c26c30a57ccd88.mp4";